import { Injectable, inject, signal } from '@angular/core';
import { BehaviorSubject, map, Observable, Subject, tap } from 'rxjs';
import { CCDropdownModelSingle, CCPostModel, DynamicFormConfig } from '../types/dynamic-form.types';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { ApiHttpService, ILayoutConfig, ItmUserService, LayoutService } from '@itm/services';
import { Utilities } from '@itm/constants/utilities';

@Injectable({
    providedIn: 'root'
})
export class AuditService {
    private readonly _http = inject(ApiHttpService);

    constructor() { }

    getById(id: any) {
        const url = 'core/audit/' + id;
        return this._http.GETT(url)
    }
}
